<template>
  <div>
    <!-- 原辅料异常 -->
    <div class="product-info">
      <div class="title">成品生产信息</div>
      <el-table :data="productList">
        <el-table-column prop="inspection_name" label="药品通用名称" />
        <el-table-column prop="inspection_number" label="药品批准文号" />
        <el-table-column prop="batch_number" label="生产批号" />
        <el-table-column prop="product_date" label="生产日期" />
        <el-table-column prop="number" label="生产数量" />
        <el-table-column label="检验报告">
          <template slot-scope="scope">
            <el-button type="text" @click="productReport(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="raw-accessory-info">
      <div class="title">相关原辅料使用信息</div>
      <el-table :data="rawAccessoryList" :cell-style="renderCell">
        <el-table-column prop="product_name" label="原辅料名称" />
        <el-table-column prop="supplier_name" label="供应商名称" />
        <el-table-column prop="batch_number" label="生产批号" />
        <el-table-column prop="product_date" label="生产日期" />
        <el-table-column prop="validity_time" label="有效期" />
        <el-table-column label="检验报告">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="rawAccessoryReport(scope.row)"
              v-if="scope.row.report_id"
              >查看详情</el-button
            >
            <span class="unnormal" v-else>缺失</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page="currentPage"
        @current-change="loadRawAccessoryList"
        :page-size="5"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ['warningId', 'currentTime'],
  data() {
    return {
      productList: [],
      rawAccessoryList: [],
      currentPage: 1,
      total: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadProductList();
      this.loadRawAccessoryList();
    },
    loadProductList() {
      this.$request({
        url: 'rest/riskwarning/detail/drugProductView',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: 1, pageSize: 100000 },
            params: {
              warningId: this.warningId
            }
          })
        }
      }).then(res => {
        this.productList = [res];
      });
    },
    loadRawAccessoryList() {
      this.$request({
        url: 'rest/riskwarning/detail/rawUseList',
        data: {
          json: JSON.stringify({
            pageBean: { pageNum: this.currentPage, pageSize: 5 },
            params: {
              warningId: this.warningId
            }
          })
        }
      }).then(res => {
        this.rawAccessoryList = res.list;
        this.total = res.total;
      });
    },
    productReport(row) {
      this.$blobFileRequest({
        url: 'reportinfo/productQualityFile',
        data: {
          id: row.id
        },
        isPdfView: true
      });
    },
    rawAccessoryReport(row) {
      this.$blobFileRequest({
        url: 'reportinfo/rawReportfile',
        data: {
          id: row.report_id
        },
        isPdfView: true
      });
    },
    renderCell({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1 && row.supplierFlag === '1') {
        return { color: '#FF4C39' };
      }
      if (columnIndex === 4 && row.outDateFlag === '1') {
        return { color: '#FF4C39' };
      }
    }
  },
  watch: {
    currentTime() {
      this.init();
    }
  }
};
</script>

<style lang="stylus" scoped>
.product-info, .raw-accessory-info
  border 1px solid #ccc
  padding 20px
  margin-bottom 20px
  .unnormal
    color #FF4C39
  .title
    font-size 16px
    color #000
    font-weight 700
    text-align center
    margin-bottom 20px
  .pagination
    text-align right
    padding-top 20px
>>>.el-button--text
    font-size 12px
</style>
